/* batida-konto-firma.js: "Prywatnie / Dla firmy" in Moje konto (sections/batida-konto-firma.liquid; phase 2, 29.09).
   Who: a customer with a saved company NIP in Batida Connect (Dane do faktury) or a company invoice (company-nip) on
   one of the last 20 orders (the section reads that in Liquid). The switch sits next to the greeting; "Dla firmy"
   adds the card "Zestawy do biura" at the top of Start: 3 office sets with live prices, the invoice line (the
   company used in the cart / how to save one), links that exist on the site. The choice is kept in the browser.
   Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="firma"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {}, L = F.links || {};
  var KEY = 'v7k-view';
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  function view() { try { return localStorage.getItem(KEY) === 'firma' ? 'firma' : 'prywatnie'; } catch (e) { return 'prywatnie'; } }
  function setView(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function nipFmt(n) { n = String(n || '').replace(/\D/g, ''); return n.length === 10 ? n.slice(0, 3) + '-' + n.slice(3, 6) + '-' + n.slice(6, 8) + '-' + n.slice(8) : n; }
  var wired = false, CTX = null;

  function render(ctx) {
    CTX = ctx;
    var hero = ctx.slot('hero', 'firma'), top = ctx.slot('start-top', 'firma');
    if (!hero || !top) return;
    var c = ctx.connect, inv = c && c.profile && c.profile.invoice;
    var nips = inv && Array.isArray(inv.nips) ? inv.nips : [];
    var eligible = ctx.DEMO || (F.on && (nips.length > 0 || !!(F.company && F.company.nip)));
    if (!eligible) { hero.innerHTML = ''; top.innerHTML = ''; return; }
    wire(ctx);
    var v = view();
    hero.innerHTML = '<div class="v7k-seg" role="group" aria-label="' + tx('seg_aria') + '">' +
      '<button type="button" data-v7k-view="prywatnie" aria-pressed="' + (v === 'prywatnie') + '">' + tx('seg_private') + '</button>' +
      '<button type="button" data-v7k-view="firma" aria-pressed="' + (v === 'firma') + '">' + tx('seg_firm') + '</button></div>';
    if (v !== 'firma') { top.innerHTML = ''; return; }
    var h = ctx.h, html = '<h2 class="v7k-h2">' + tx('title') + '</h2>' + (T.sub ? '<p class="v7k-sub">' + tx('sub') + '</p>' : '');
    var P = Array.isArray(F.products) ? F.products : [];
    if (P.length) {
      html += '<div class="v7k-team">' + P.map(function (p) {
        return '<a class="v7k-team__p" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="120" height="120">' : '') +
          '<span><b>' + esc(p.title) + '</b><span>' + esc(h.money(p.price)) + '</span></span></a>';
      }).join('') + '</div>';
    }
    /* the invoice line: only what really happens in the cart (assets/batida-konto-cart.js fills the FIRST saved company
       when "Zawsze dodawaj fakturę" is on) */
    if (nips.length && inv.always) {
      html += '<p class="v7k-firm__inv">' + tx('inv_line', { firma: '<b>' + esc(nips[0].name || nipFmt(nips[0].nip)) + '</b>', nip: esc(nipFmt(nips[0].nip)) }) + '</p>';
    } else if (c) {
      html += '<p class="v7k-firm__inv">' + tx('inv_hint') + ' <button type="button" class="v7k-linkbtn" data-v7k-go="faktury">' + tx('inv_go') + '</button></p>';
    }
    var links = [['sets', 'link_sets'], ['catering', 'link_catering'], ['piatek', 'link_piatek'], ['b2b', 'link_b2b']].filter(function (x) { return L[x[0]] && T[x[1]]; });
    if (links.length) html += '<p class="v7k-acts">' + links.map(function (x) { return '<a class="v7k-link" href="' + esc(L[x[0]]) + '">' + tx(x[1]) + ' <span aria-hidden="true">→</span></a>'; }).join('') + '</p>';
    top.innerHTML = h.box('s12 v7k-firm', html);
  }
  function wire(ctx) {
    if (wired) return;
    wired = true;
    ctx.app.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-v7k-view]'); if (!b) return;
      setView(b.getAttribute('data-v7k-view')); render(CTX);
    });
  }

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'firma', render: render });
})();
